import axios from 'axios';
import feathers from '../feathers';
import { toast } from 'react-toastify';

var nextToLogin = (userResult) => {
  let url = window.location.hostname + window.auth.redirectLogin;
  console.log('url', url);
  window.location.replace = url;
};

var auth = {
  config: (options = {}) => {
    options = {
      ...{
        redirectLogin: '/#/admin',
        redirectNotLogin: '/#/',
        redirectNotAuthorization: '/#/notRole',
      },
      options,
    };

    window.auth = options;

    var _this = this;

    //Iniciar la authorización si existe al inicio
    if (localStorage.getItem('token')) {
      axios.defaults.headers.common['Authorization'] =
        localStorage.getItem('token');
    }

    var renewToken = async () => {
      //Ingresa de Nuevo
      return new Promise(async (resolve, reject) => {
        try {
          let user = localStorage.getItem('email');
          let password = localStorage.getItem('password');
          var url = process.env.REACT_APP_URL_API + '/api/users/login';
          var postBody = {
            email: user,
            password: password,
          };
          var loginResponse = await axios.post(url, postBody);

          var dateNow = new Date();
          var seconds = dateNow.getTime() / 1000;
          localStorage.setItem('expiration', seconds + loginResponse.data.ttl);

          resolve(loginResponse.data.id);
        } catch (error) {
          console.log('error->', error);
          reject(error);
        }
      });
    };

    axios.interceptors.request.use(
      async function (config) {
        // Do something before request is sent
        let originalRequest = config;
        let tokenIsExpired = isExpiredToken;
        let logintContain = config.url.includes('login');

        if (logintContain) {
          return config;
        } else {
          let expiration = localStorage.getItem('expiration');

          var isExpiredToken = false;

          var dateNow = new Date();

          if (expiration !== null) {
            if (expiration < dateNow.getTime() / 1000) {
              isExpiredToken = true;
            }
          } else {
            window.location.href = '/';
          }

          if (tokenIsExpired) {
            console.log('Renew Token');
            try {
              let token = await renewToken();
              originalRequest.headers['Authorization'] = token;
              axios.defaults.headers.common['Authorization'] = token;

              localStorage.setItem('token', token);

              console.log('config===>', originalRequest);

              return originalRequest;
              // return Promise.resolve(originalRequest);
            } catch (err) {
              console.log('error renew', err);
              return Promise.reject(err);
            }
          } else {
            return config;
          }
        }
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response;
      },
      function (error) {
        console.error('Error', error.response);
        toast.error(
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.message) ||
            (error && error.response && error.response.statusText) ||
            'Error al realizar la petición'
        );
        // Do something with response error

        if (error.response !== undefined) {
          if (error.response.status === 401) {
            console.log('Unauthorized');
            // auth.logout();
          }

          if (error.response.status === 403) {
            console.log('Not Role for this');
            auth.redirectNotAuthorization();
          }

          if (error.response.status === 401) {
            console.log('Not Role for this');
            auth.logout();
          }
        }

        return Promise.reject(error.response);
      }
    );

    window.auth = options;
  },
  getConfig: () => {
    return window.auth;
  },
  redirectNotAuthorization: () => {
    console.log('no autorizado a entrar aquí');
    window.location.href = window.auth.redirectNotAuthorization;
  },
  setCurrentUser: (user) => {
    localStorage.setItem('user', user);
  },
  getCurrentUser: () => {
    let currentUser = JSON.parse(localStorage.getItem('user'));
    return currentUser;
  },
  can: (rolesCan) => {
    var can = false;
    var user = auth.getCurrentUser();

    if (user !== null) {
      user.roles.map((role) => {
        if (rolesCan.includes(role)) {
          can = true;
        }
      });
      return can;
    } else {
      return can;
    }
  },
  canAccess: (roles = []) => {
    if (auth.isLogin()) {
      if (!auth.can(roles)) {
        auth.redirectNotAuthorization();
      }
    } else {
      auth.logout();
    }
  },
  onLogin: (token, userId = '', user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    axios.defaults.headers.common['Authorization'] = token;
    axios.defaults.headers.common['UserId'] = userId;
    axios.defaults.headers.common['FranchiseId'] = user.franchiseId;
  },
  getLogin: () => {
    var token = localStorage.getItem('token');
    var userId = localStorage.getItem('userId');
    return { token, userId };
  },
  login: (email, password, nextToLogin = nextToLogin) => {
    return new Promise(async (resolve, reject) => {
      try {
        localStorage.setItem('email', email);
        localStorage.setItem('password', password);
        var loginResult = await axios.post(
          process.env.REACT_APP_URL_API + '/api/users/login',
          {
            email: email,
            password: password,
          }
        );

        var dateNow = new Date();
        var seconds = dateNow.getTime() / 1000;
        localStorage.setItem('expiration', seconds + loginResult.data.ttl);

        var params = {
          include: ['roles', 'franchise'],
        };
        var userResult = await axios.get(
          process.env.REACT_APP_URL_API +
            '/api/users/' +
            loginResult.data.userId +
            '?filter=' +
            JSON.stringify(params),
          { headers: { Authorization: loginResult.data.id } }
        );

        var roles = [];
        if (userResult.data.roles !== undefined) {
          userResult.data.roles.map((role) => roles.push(role.name));
          userResult.data.roles = roles;
        } else {
          userResult.data.roles = [];
        }

        auth.onLogin(
          loginResult.data.id,
          loginResult.data.userId,
          userResult.data
        );
        auth.setCurrentUser(JSON.stringify(userResult.data));

        nextToLogin(userResult.data);

        resolve();
      } catch (e) {
        console.log('e', e);
        if (
          e.message === 'Request failed with status code 400' ||
          e.message === 'Request failed with status code 401'
        ) {
          reject('Email o contraseña incorrectos');
        } else {
          reject('Error al iniciar');
        }
      }
    });
  },
  isLogin: () => {
    if (localStorage.getItem('token') !== null) {
      let currentUser = auth.getCurrentUser();
      if (currentUser === null) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  },
  verifyLogin: () => {
    if (!auth.isLogin()) {
      auth.logout();
      return false;
    } else {
      return true;
    }
  },
  verifyRealLogin: () => {
    // TODO hacer una verificación directamente en el servidor.
  },
  logout: (redirect = '/') => {
    redirect = window.auth !== undefined ? window.auth.redirectNotLogin : '/';
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    axios.defaults.headers.common['Authorization'] = undefined;
    axios.defaults.headers.common['UserId'] = undefined;
    axios.defaults.headers.common['FranchiseId'] = undefined;
    if (redirect !== false) {
      window.location.href = redirect;
    }
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/libCustom/auth.js